import { Component, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";

import { TextsElementAccessor } from "../texts-accessor";

/**
 * Text fields allow users to enter text into a UI. They typically appear in forms and dialogs. Line-breaks are automatically removed from the input value.
 *
 * Text inputs can be used as an Angular `FormControl`, in both reactive and template driven forms.
 */
@Component({
  selector: "ui-input[type=text]",
  templateUrl: "./text.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTextComponent extends TextsElementAccessor {}
